jQuery(document).ready(function onProductPageReady($) {
    'use strict';

    $('.product-info-menu .general-info').on('click', function(e) {
        e.preventDefault();

        $.drawer({
            title: '<i class="fi flaticon-theatre-masks"></i> Evenemangsinfo',
            content: window.npr_data.templates.event,
        }).show();
    });

    $('.product-info-menu .ticket-info').on('click', function(e) {
        e.preventDefault();

        $.drawer({
            title: '<i class="fi flaticon-theatre-masks"></i> Biljettinformation',
            content: window.npr_data.templates.tickets,
        }).show();
    });

    $('.product-info-menu .hotels').on('click', function(e) {
        e.preventDefault();

        $.drawer({
            title: '<img src="/wp-content/themes/nojesresor/static/images/our-hotels.svg"> Våra hotell',
            content: window.npr_data.templates.hotels,
        }).show(function($el, close) {
            requestAnimationFrame(function() {
                const swiperOptions = {
                    slidesPerView: 1.5,
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                    spaceBetween: 16,
                    navigation: {
                        nextEl: $el.find('.navigation--next').get(0),
                        prevEl: $el.find('.navigation--prev').get(0),
                    },
                    breakpoints: {
                        575: {
                            slidesPerView: 2.5,
                        },
                        768: {
                            slidesPerView: 3.5,
                        },
                    },
                };

                new Swiper($el.find('.hotel-slider').get(0), swiperOptions);
                $('.hotel-slider__hotel').on('click', close);
            });
        });
    });

    $('.product-info-menu .arena-theater').on('click', function(e) {
        e.preventDefault();

        $.drawer({
            title: '<i class="fi flaticon-theatre-masks"></i> Arena/teater',
            content: window.npr_data.templates.venue,
        }).show(function($el) {
            requestAnimationFrame(function() {
                $el.find('.tabs').tabs();

                $el.find('.js-venue-map').venueMap(
                    npr_data.data.hotels.filter(function(hotel) {
                        return hotel.map != null;
                    }).map(function(hotel) {
                        return {
                            title: hotel.name,
                            address: hotel.address,
                            coordinates: [
                                parseFloat(hotel.map.lng),
                                parseFloat(hotel.map.lat),
                            ],
                        };
                    }),
                );
            });
        });
    });

    $('.product-info-menu .group-company-info').on('click', function(e) {
        e.preventDefault();

        $.drawer({
            title: npr_data.templates.groupHeader,
            content: npr_data.templates.group,
        }).show();
    });

    $('.product-info-menu .family-room-info').on('click', function(e) {
        e.preventDefault();

        $.drawer({
            title: npr_data.templates.familyHeader,
            content: npr_data.templates.family,
        }).show();
    });

    $('.product-info-menu .cancellation-insurance').on('click', function(e) {
        e.preventDefault();

        $.drawer({
            title: npr_data.templates.cancellationInsuranceHeader,
            content: npr_data.templates.cancellationInsurance,
        }).show();
    });

    // Desktop.
    (function($) {
        const $read_more_button = $('.js-read-more-button');

        if ($('.single-product__wrapper').length === 0) {
            return;
        }

        const $desktopHotelSliderContainer = $('.js-desktop-hotel-slider');

        const swiperOptions = {
            slidesPerView: 3.5,
            spaceBetween: 16,
            navigation: {
                nextEl: $desktopHotelSliderContainer.find('.navigation--next')
                    .get(0),
                prevEl: $desktopHotelSliderContainer.find('.navigation--prev')
                    .get(0),
            },
        };

        const hotelSlider = new Swiper(
            $desktopHotelSliderContainer.get(0),
            swiperOptions,
        );

        window.hotelSlider = hotelSlider;

        $('.js-product-info-tabs')
            .tabs()
            .on('tabchange', function(e, tab) {
                hotelSlider.update();
            });

        $read_more_button.on('click', onClickReadMore);

        function onClickReadMore(e) {
            e.preventDefault();

            $('.js-single-product-header-summary-description')
                .clampedText('toggle');

            const is_expanded_summary = $(
                '.js-single-product-header-summary-description',
            )
                .hasClass('clamped-text--expanded');

            $read_more_button.find('.plus-icon')
                .toggleClass('plus-icon--active');

            var text = is_expanded_summary
                ? ' Stäng'
                : ' Läs mer';

            $read_more_button.contents().each(function() {
                if (
                    this.nodeType === Node.TEXT_NODE &&
                    this.nodeValue.trim().length > 0
                ) {
                    this.textContent = text;
                }
            });
        }
    }(jQuery));

    // General.
    (function($) {
        $(document).on('click', '.hotel-slider__hotel', onClickHotel);

        function onClickHotel() {
            var $overlay = createOverlay();
            var $popup = createPopup();
            $overlay.append($popup);

            $('body').append($overlay);

            requestAnimationFrame(function() {
                window.nojesresor.utils.lockBodyScrolling('dialog');

                $overlay.addClass('dialog-overlay--visible');
            });

            $overlay.on('click', onClose.bind($overlay.get(0), $overlay));
        }

        function createOverlay() {
            return $('<div class="dialog-overlay"></div>');
        }

        function createPopup() {
            return $(
                '<div class="dialog dialog--information dialog--hotel-next-step">' +
                '<div class="dialog__wrapper">' +
                '<h2>Välj hotell i nästa steg</h2>' +
                '<p>Välj datum och biljettkategori längre ner på sidan för att se vilka hotell som finns tillgängliga för just er bokning.</p>' +
                '<button class="button button--blue">OK</button>' +
                '</div>' +
                '</div>',
            );
        }

        function onClose($overlay) {
            $overlay.removeClass('dialog-overlay--visible');

            window.nojesresor.utils.unlockBodyScrolling('dialog');

            setTimeout(function() {
                $overlay.remove();
            }, 300);
        }
    }(jQuery));

    (function($) {
        var $elements = $('.tabs');
        for (var i = 0, l = $elements.length; i < l; ++i) {
            tabs($($elements[i]));
        }

        function tabs($tabs) {
            var active_navigation_class = 'tabs__tab-navigation__tab-button--active';

            var $navigation_buttons = $tabs.find(
                '.tabs__tab-navigation__tab-button');
            var $views = $tabs.find('.tabs__tab-wrapper__tab');

            var $active_view = $($views[0]);
            var $active_navigation_button = $($navigation_buttons[0]);
            $views.hide();
            $views.filter($active_view).show();
            $active_navigation_button.addClass(active_navigation_class);

            for (var i = 0, l = $navigation_buttons.length; i < l; ++i) {
                $($navigation_buttons[i]).on('click', goToTab.bind(null, i));
            }

            function goToTab(index, e) {
                e.preventDefault();

                $active_view.hide();
                $active_view = $($views[index]);
                $active_view.show();

                $active_navigation_button.removeClass(active_navigation_class);
                $active_navigation_button = $($navigation_buttons[index]);
                $active_navigation_button.addClass(active_navigation_class);

                // Update swiper UI
                document.querySelector('.single-product__mobile-header__tabs')
                    .swiper
                    .update();
            }
        }
    }(jQuery));

    (function($) {
        var $link = $('.js-toggle-single-product-summary');
        $link.on('click', onClick);

        var is_toggled = false;

        var texts = {
            untoggled: 'Läs mer',
            toggled: 'Stäng',
        };

        function onClick(e) {
            e.preventDefault();

            is_toggled = !is_toggled;

            $link.text(
                is_toggled
                    ? texts.toggled
                    : texts.untoggled,
            );

            $('.js-single-product-summary')
                .toggleClass(
                    'single-product__header__summary-text-container--show-all');
        }
    }(jQuery));

    // Group/Company info popup
    (function($) {
        const groupCompany = $('.group-company-info');
        if(groupCompany) {
            $( document ).on( 'click', '.group-company-info__overlay__toggle', function(e){
                e.preventDefault();
                $('.group-company-info-popup__overlay').addClass('visible');
                $('body').css('overflow', 'hidden');
            });
            $( document ).on( 'click', '.group-company-info-popup__close', function(e){
                e.preventDefault();
                $('.group-company-info-popup__overlay').removeClass('visible');
                $('body').css('overflow', 'auto');
            });
            $( document.body ).on( 'click', '.group-company-info-popup__overlay', function(e){
                if (e.target !== this)
                    return;
                $('.group-company-info-popup__overlay').removeClass('visible');
                $('body').css('overflow', 'auto');
            });

        }
    }(jQuery));

    // Family room info popup
    (function($) {
        const familyRoom = $('.family-room-info');
        if(familyRoom) {
            $( document ).on( 'click', '.family-room-info__overlay__toggle', function(e){
                e.preventDefault();
                $('.family-room-info-popup__overlay').addClass('visible');
                $('body').css('overflow', 'hidden');
            });
            $( document ).on( 'click', '.family-room-info-popup__close', function(e){
                e.preventDefault();
                $('.family-room-info-popup__overlay').removeClass('visible');
                $('body').css('overflow', 'auto');
            });
            $( document.body ).on( 'click', '.family-room-info-popup__overlay', function(e){
                if (e.target !== this)
                    return;
                $('.family-room-info-popup__overlay').removeClass('visible');
                $('body').css('overflow', 'auto');
            });

        }
    }(jQuery));

});

